import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../../services/api';

const Step8Additional = () => {
    const { mockUser, refreshUser } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    
    const [formData, setFormData] = useState({
        isTwin: 'N', // Y=Yes, N=No
        captcha: ''
    });

    // Load Data
    useEffect(() => {
        const init = async () => {
            try {
                const res = await api.get(`/mock-cuet/application-data?mockAppId=${mockUser.id}`);
                if (res.data.success) {
                    const db = res.data.data;
                    setFormData(prev => ({
                        ...prev,
                        isTwin: db.is_twin === 1 ? 'Y' : 'N'
                    }));
                }
            } catch (err) { console.error(err); }
        };
        init();
    }, [mockUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Simulation Confirmation
        if(!window.confirm('Are you sure you want to submit this section?')) {
            return;
        }

        setLoading(true);

        try {
            const res = await api.post('/mock-cuet/save-step', {
                mockAppId: mockUser.id,
                stepNumber: 8,
                stepData: formData,
                nextStepNumber: 9
            });

            if (res.data.success) {
                refreshUser(9);
                navigate('/services/counselling/dashboard/emergency-contact');
            }
        } catch (err) {
            alert("Error saving data.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="ctl00_ContentPlaceHolder1_pnlApplicationForm">
            <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
                
                <div id="ctl00_ContentPlaceHolder1_pnlGateDetails">
                    <h4>
                        <span id="ctl00_ContentPlaceHolder1_lblGateSectionHeader">अतिरिक्त जानकारियां (Additional Details)</span>
                    </h4>
                    
                    <div className="form-horizontal formLabel">
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                <span id="ctl00_ContentPlaceHolder1_lblGateQualifiedCap">
                                    क्या आप जुड़वा हैं और दोनों सीयूईटी (यूजी) 2026 के लिए आवेदन कर रहे हैं (Are you a Twin and both applying for CUET (UG) 2026) ?
                                </span>
                            </label>
                            <div className="col-sm-4">
                                <select 
                                    name="isTwin" 
                                    className="form-control" 
                                    value={formData.isTwin} 
                                    onChange={handleChange}
                                >
                                    <option value="0">--Select--</option>
                                    <option value="N">No</option>
                                    <option value="Y">Yes</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* CAPTCHA SECTION */}
                <div className="form-horizontal formLabel">
                    <h4>CAPTCHA</h4>
                    <div className="form-group">
                        <label className="control-label col-sm-4">
                            Enter CAPTCHA as shown below <small className="text-primary">(case sensitive) </small>
                        </label>
                        <div className="col-sm-4">
                            <input 
                                name="captcha" 
                                type="text" 
                                className="form-control" 
                                value={formData.captcha} 
                                onChange={handleChange}
                                required 
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="control-label col-sm-4">CAPTCHA</label>
                        <div className="col-sm-4">
                             <div style={{display:'inline-block', verticalAlign:'middle'}}>
                                <img src="/assets/cuet-mock/images/DisplayCaptchaImg.jpg" alt="Captcha" style={{height:'34px', borderWidth:'0px'}} />
                             </div>
                             <div style={{display:'inline-block', verticalAlign:'middle', marginLeft:'10px'}}>
                                <img src="/assets/cuet-mock/images/Refresh.png" alt="Refresh" style={{height:'30px', width:'30px', cursor:'pointer'}} />
                             </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="form-group">
                            <div className="col-sm-12 text-center" style={{marginTop:'20px'}}>
                                <button type="button" className="btn btn-warning" onClick={() => navigate('/services/counselling/dashboard/qualification-details')} style={{marginRight:'10px'}}>
                                    Back
                                </button>
                                <button type="submit" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
                                    {loading ? 'Saving...' : 'Save & Next'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Step8Additional;